import React from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Divider,
  Fade,
  Backdrop,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

const AutobiaModal = ({
  open,
  onClose,
  title,
  children,
  maxWidth = "sm",
  hideCloseButton = false,
  closeOnBackdropClick = true,
  showDivider = true,
}) => {
  const theme = useTheme();

  const sizeMap = {
    xs: "400px",
    sm: "600px", 
    md: "800px",
    lg: "1000px",
    xl: "1200px",
  };

  const modalWidth = sizeMap[maxWidth] || sizeMap.sm;

  const handleClose = (event, reason) => {
    if (!closeOnBackdropClick && reason === "backdropClick") {
      return;
    }
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 300,
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Fade in={open} timeout={300}>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            maxWidth: modalWidth,
            maxHeight: "90vh",
            bgcolor: "background.paper",
            borderRadius: "16px",
            boxShadow: theme.shadows[8],
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              p: 3,
              pb: showDivider ? 2 : 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexShrink: 0,
            }}
          >
            <Typography variant="h6" fontWeight={600}>
              {title}
            </Typography>
            {!hideCloseButton && (
              <IconButton
                onClick={onClose}
                size="small"
                sx={{
                  color: "gray.g500",
                  "&:hover": {
                    backgroundColor: "gray.g100",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            )}
          </Box>

          {/* Divider */}
          {showDivider && <Divider />}

          {/* Content */}
          <Box
            sx={{
              p: 3,
              pt: showDivider ? 3 : 0,
              flex: 1,
              overflowY: "auto",
            }}
          >
            {children}
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default AutobiaModal;